
$(document).ready(function () {
    var $backButtonCheckout = $('.back-button-checkout');
    var bestseller = $backButtonCheckout.attr('data-bestseller');
    var cartseller = $backButtonCheckout.attr('data-cart');
    var loginlink = $backButtonCheckout.attr('data-login');
    var customerType = $backButtonCheckout.attr('data-customer-type');

    if($('#cart-page-container').length > 0 && bestseller){
        $backButtonCheckout.attr('href',bestseller);
    }else if($('#checkout-main').length > 0 && loginlink && customerType === "guest"){
        $backButtonCheckout.attr('href', window.history.back());
    }else if ($('#checkout-main').length > 0 && cartseller && customerType === "registered"){
        $backButtonCheckout.attr('href', cartseller);
    }else if($('.blockBreadcrumbs-checkoutLogin-cart').length > 0 && cartseller){
        $backButtonCheckout.attr('href', cartseller);
    }
});